import { logout } from 'util/api'
import { useDocTitle } from 'util/hooks'
import { verifyLogin } from 'util/cache'
import { StudentFooter } from 'components/footer'

import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import 'css/pages/verification.css'
import styles from 'css/pages/enter-code.module.css'
import logo from 'img/logo_main-cropped.svg'

export const EnterCode = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const firstName = localStorage.getItem('firstName')

    // Check if we were redirected here with an error (expired/invalid code)
    const locationState = location.state as { error?: string } | null
    const [error, setError] = useState<string | null>(locationState?.error ?? null)

    useEffect(() => {
        verifyLogin(navigate)
    }, [])

    const [ code, setCode ] = useState<string>()

    const onCodeChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
        setCode(target.value)
        setError(null)

        if (target.value.match(/^\d{6}$/)) {
            target.setCustomValidity('')
            return
        }

        target.setCustomValidity('The code should be a 6-digit number.')
    }

    const onFormSubmit = async (event: React.FormEvent) => {
        event.preventDefault()
        if (!code || !code.match(/^\d{6}$/)) {
            setError('Please enter a valid 6-digit code.')
            return
        }
        setError(null)
        navigate(`/live/${code}`)
    }

    const handleLogout = async () => {
        await logout()
        localStorage.removeItem('loggedIn')
        localStorage.removeItem('studentId')
        localStorage.removeItem('firstName')
        navigate('/login')
    }

    useDocTitle('All for One - Enter Code')

    return (
        <div className={styles.shell}>
            <header className={styles.header}>
                <img src={logo} className={styles.logo} alt="All for One" />
                <button onClick={handleLogout} className={styles.logoutBtn}>Log out</button>
            </header>
            <main className={styles.main}>
                <section className="verification-container">
                    <h1 className="verification-header">
                        {firstName
                            ? <>Hi, <span className="highlight">{firstName}!</span></>
                            : <>Enter <span className="highlight">class code</span></>
                        }
                    </h1>

                    <p className="verification-instruction">
                        Ask your teacher for the 6-digit class code and enter it below.
                    </p>

                    {error && (
                        <p style={{ color: '#e74c3c', fontWeight: 'bold', margin: '0 0 12px', fontSize: '14px' }}>
                            {error}
                        </p>
                    )}

                    <form
                        id="enter-code-form"
                        action="#"
                        method="POST"
                        onSubmit={onFormSubmit}
                    >
                        <div className="form-group">
                            <input
                                type="tel"
                                id="code"
                                name="code"
                                placeholder="6-digit code"
                                required
                                onChange={onCodeChange}
                            />
                        </div>

                        <div className="form-group">
                            <button type="submit" className="verification-btn">Next</button>
                        </div>
                    </form>
                </section>
            </main>
            <StudentFooter />
        </div>
    )
}
